import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../../utils/styledComponent';
import theme from '../../../theme';
import { PHASE_DAY_OF, PHASE_PREP, formatChipDate } from './utils';

const StyledStrip = styledComponent('div', {
  display: 'flex',
  gap: theme.spacing.inputLabelGap,
  flexWrap: 'wrap',
  alignItems: 'center',

  '& .dp-toggle-btn': {
    background: theme.colors.bgCard,
    border: `1px solid ${theme.colors.border}`,
    padding: '8px 12px',
    borderRadius: theme.radii.inner,
    fontSize: theme.typography.body.fontSize,
    fontWeight: theme.fontWeights.medium,
    color: theme.colors.text,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing.gapXs,
    minWidth: '84px',
    transition: 'all 0.15s',
  },

  '& .dp-toggle-btn:hover': {
    borderColor: theme.colors.accent,
    background: theme.colors.accentSoftBg,
  },

  '& .dp-toggle-btn.is-active': {
    borderColor: theme.colors.accent,
    background: theme.colors.accent,
    color: theme.colors.white,
  },

  '& .dp-toggle-label': {
    fontSize: theme.typography.microLabel.fontSize,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    opacity: 0.7,
  },

  '& .dp-toggle-num': {
    fontSize: '16px',
    fontWeight: theme.fontWeights.semibold,
  },
});

function DayPhaseToggle({ selectedPhase, onChange, dayOfDate }) {
  return (
    <StyledStrip role="tablist" aria-label="Operational phase">
      <button
        type="button"
        className={`dp-toggle-btn${
          selectedPhase === PHASE_PREP ? ' is-active' : ''
        }`}
        onClick={() => onChange(PHASE_PREP)}
        aria-pressed={selectedPhase === PHASE_PREP}
        data-testid="toggle-prep"
      >
        {/* Prep shares Day Of's upcoming stocking date, so it shows a label
            only; the date lives on the Day Of button. */}
        <span className="dp-toggle-label">Prep</span>
      </button>
      <button
        type="button"
        className={`dp-toggle-btn${
          selectedPhase === PHASE_DAY_OF ? ' is-active' : ''
        }`}
        onClick={() => onChange(PHASE_DAY_OF)}
        aria-pressed={selectedPhase === PHASE_DAY_OF}
        data-testid="toggle-day-of"
      >
        <span className="dp-toggle-label">Day Of</span>
        <span className="dp-toggle-num">{formatChipDate(dayOfDate)}</span>
      </button>
    </StyledStrip>
  );
}

DayPhaseToggle.propTypes = {
  selectedPhase: PropTypes.oneOf([PHASE_DAY_OF, PHASE_PREP]).isRequired,
  onChange: PropTypes.func.isRequired,
  dayOfDate: PropTypes.instanceOf(Date).isRequired,
};

export default DayPhaseToggle;
